import { LogOut } from "lucide-react";
import { useRef } from "react";
import { useAuth } from "@/auth/useAuth";
import { chooseLanguage } from "@/i18n";
import { Button } from "./ui/button";
import { useTranslation } from "react-i18next";
import { useHolyMode } from "@/preferences/holy-mode";
import { SacredIcon } from "./sacred-icon";
import { CelestialAudio, type CelestialAudioHandle } from "./celestial-audio";

export function UserMenu() {
  const { markNoAccess } = useAuth();
  const { enabled, toggle } = useHolyMode();
  const celestialAudio = useRef<CelestialAudioHandle>(null);
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage === "en" ? "en" : "pt-BR";
  return (
    <div className="bible-app-user-menu flex items-center gap-1">
      <button
        type="button"
        role="switch"
        aria-label={t("holy.toggleLabel")}
        aria-checked={enabled}
        className="holy-mode-toggle"
        onClick={() => {
          if (!enabled) celestialAudio.current?.activate();
          toggle();
        }}
      >
        <span className="holy-mode-toggle__seal" aria-hidden="true">
          <SacredIcon name={enabled ? "seal" : "cross"} size={19} />
        </span>
        <span className="holy-mode-toggle__label">{t("holy.toggleLabel")}</span>
        <span className={`holy-mode-toggle__state${enabled ? " is-on" : ""}`}>{enabled ? "ON" : "OFF"}</span>
      </button>
      <CelestialAudio ref={celestialAudio} enabled={enabled} />
      <div role="group" aria-label={t("userMenu.language")} className="flex items-center gap-0.5">
        <Button variant="ghost" size="sm" aria-label="PT" aria-pressed={language === "pt-BR"} onClick={() => void chooseLanguage("pt-BR")}>PT</Button>
        <Button variant="ghost" size="sm" aria-label="EN" aria-pressed={language === "en"} onClick={() => void chooseLanguage("en")}>EN</Button>
      </div>
      <Button variant="ghost" size="sm" onClick={markNoAccess}>
        <LogOut size={14} aria-hidden /> {t("userMenu.signOut")}
      </Button>
    </div>
  );
}
